import React from 'react'
import {useLocation} from 'react-router'
import {PATH_MAILING} from '../../../routing/paths'
import {NavLinkInterface, NavLinksHeader} from '../../../@components'

const navLinks: NavLinkInterface[] = [
  {path: PATH_MAILING.contacts.root, label: 'Listes de contacts'},
  {path: PATH_MAILING.contacts.subscribers, label: 'Abonnés'},
]

const ContactsHeader = () => {

  const location = useLocation()

  return (
    <NavLinksHeader navLinks={navLinks} pathname={location.pathname} />
  )
}

export {ContactsHeader}